
import React from 'react';
import { Package, AlertTriangle, Utensils, Droplets, Sparkles, Archive, Wheat, Apple, Milk, Fish, Beef, Soup, Coffee, Wine, ShoppingBasket, Cookie, Salad, Pizza } from 'lucide-react';

interface CategoryIconProps {
  category: string;
  className?: string;
}

const CategoryIcon = ({ category, className = "h-4 w-4 text-nautic" }: CategoryIconProps) => {
  const getCategoryIcon = (category: string) => {
    switch (category.toLowerCase()) {
      case 'alimentation':
        return Utensils;
      case 'boissons':
        return Droplets;
      case 'hygiène':
        return Sparkles;
      case 'sécurité':
        return AlertTriangle;
      case 'équipements':
        return Package;
      default:
        return Package;
    }
  };

  const Icon = getCategoryIcon(category);
  return <Icon className={className} />;
};

export default CategoryIcon;
